import React, { KeyboardEvent } from 'react'
import { Icon, IconChoices } from '../Icon'
import { Spinner } from '../Spinner'
import { cn } from '../../../helpers/utils'

interface ImageBaseProps {
  onClick?: () => void
  onDeleteClick?: () => void
  alt?: string
  className?: string
  style?: React.CSSProperties
  imageClassName?: string
  imageStyle?: React.CSSProperties
  shouldCloseTopRight?: boolean
  objectFit?: string
  disabled?: boolean
}
interface ImageProps extends ImageBaseProps {
  url: string | undefined
}

export const Image = ({
  url,
  alt = 'image',
  onClick,
  onDeleteClick,
  className,
  style,
  imageClassName,
  shouldCloseTopRight = false,
  imageStyle,
  objectFit,
  disabled,
}: ImageProps): JSX.Element => {
  const handleKeyDown = (e: KeyboardEvent<HTMLImageElement>): void => {
    if (e.key === 'Enter' && onClick) {
      onClick()
    }
  }

  return (
    <div
      className={cn(
        `relative ${
          onClick && !disabled ? 'cursor-pointer' : ''
        } h-full w-full items-center justify-center `,
        className
      )}
      role="button"
      tabIndex={onClick ? 0 : -1}
      style={{ maxWidth: '100%', maxHeight: '100%', ...style }}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      {url ? (
        <img
          alt={alt}
          className={cn(
            `h-full w-full object-cover`,
            objectFit,
            imageClassName
          )}
          src={url}
          style={imageStyle}
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <Spinner />
        </div>
      )}
      {onDeleteClick &&
        (!shouldCloseTopRight ? (
          <button
            className="absolute right-2 top-2 rounded-2xl bg-neutral-90 bg-opacity-70
                p-1 hover:bg-opacity-100"
            onClick={(e) => {
              e.stopPropagation()
              onDeleteClick()
            }}
            type="button"
          >
            <Icon icon={IconChoices.DELETE_TRASH} />
          </button>
        ) : (
          <button
            className="absolute -right-3 -top-3 rounded-2xl p-1 hover:bg-gray-light"
            onClick={(e) => {
              e.stopPropagation()
              onDeleteClick()
            }}
            type="button"
          >
            <Icon icon={IconChoices.CLOSE} />
          </button>
        ))}
    </div>
  )
}

interface FixedHeightImageWithBackgroundProps extends ImageProps {
  wrapperClassNames: string
}

export const FixedHeightImageWithBackground = ({
  wrapperClassNames,
  ...props
}: FixedHeightImageWithBackgroundProps): JSX.Element | null => {
  return (
    <div
      className={`flex justify-center rounded-md bg-neutral-96 ${
        wrapperClassNames ?? ''
      }`}
    >
      <Image objectFit="object-contain" {...props} />
    </div>
  )
}
